import { useEffect, useState } from 'react';
import { Action, AdvisoryContent, LoadView } from '../../common/global-types/AdvisoryContent';
import config from '../../config';
import Block from './block/Block';
import Overlay from './overlay/Overlay';
import '@ids/web-component-icon';
import '../../main.css';

type AdvisoryTypeSelectorProps = {
  advisoryContent: AdvisoryContent[]  | undefined;
};

function AdvisoryTypeSelector({
  advisoryContent
}: AdvisoryTypeSelectorProps) {
  const [viewId, setViewId] = useState<number | undefined>(advisoryContent ? advisoryContent[0].initialView : undefined);

  useEffect(() => {
    const handleAdvisoryActionEvent = (event: Event) => {
      const customEvent = event as CustomEvent;
      const loadViews = customEvent.detail as LoadView[] | undefined;

      if (!loadViews) return;

      const loadedViews = loadViews?.filter(loadView =>
        advisoryContent?.[0].contentCode === loadView.contentCode
      );

      if (loadedViews && loadedViews.length > 0) {
        const foundViewId = advisoryContent?.[0].contentViews?.find((cv) => cv.contentViewId === loadedViews[0].viewId)?.contentViewId;
        setViewId(foundViewId);
      }
    };
    addEventListener(config.ADVISORY_ACTION_EVENT, handleAdvisoryActionEvent);
  
    return () => {
      removeEventListener(config.ADVISORY_ACTION_EVENT, handleAdvisoryActionEvent);
    };
  }, [advisoryContent]);

  const dispatchActionEvent = async (action: Action) => {
    const event = new CustomEvent(
      config.ADVISORY_ACTION_EVENT,
      { 
        detail: action.loadViews,
        cancelable: false,
        bubbles: true,
        composed: true
      }
    );
    dispatchEvent(event);
  };

  if (advisoryContent === undefined) return null;

  if (advisoryContent[0].advisoryType === 'block') {
    return (
      <Block
        content={advisoryContent[0]}
        viewId={viewId}
        dispatchActionEvent={dispatchActionEvent}
      />
    )
  }

  if (advisoryContent[0].advisoryType === 'overlay') {
    return (
      <Overlay
        content={advisoryContent[0]}
        viewId={viewId}
        dispatchActionEvent={dispatchActionEvent}
      />
    )
  }

  return null;
}

export default AdvisoryTypeSelector;
